import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the collaboratorsSummary state domain
 */

const selectCollaboratorsSummaryDomain = (state) =>
  state.get("collaboratorsSummary", initialState)

/**
 * Other specific selectors
 */
export const makeSelectSummary = () =>
  createSelector(selectCollaboratorsSummaryDomain, (state) =>
    state.get("summary")
  )

export const makeSelectIsLoadingSummary = () =>
  createSelector(selectCollaboratorsSummaryDomain, (state) =>
    state.get("isLoadingSummary")
  )
// percentage
export const makeSelectPercentage = () =>
  createSelector(selectCollaboratorsSummaryDomain, (state) =>
    state.get("percentage")
  )
// error
export const makeSelectError = () =>
  createSelector(selectCollaboratorsSummaryDomain, (state) =>
    state.get("error")
  )
/**
 * Default selector used by CollaboratorsSummary
 */

const makeSelectCollaboratorsSummary = () =>
  createSelector(selectCollaboratorsSummaryDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectCollaboratorsSummary
export { selectCollaboratorsSummaryDomain }
